export default {
  type: "Feature",
  properties: {
    name: "Зуунмод",
    location: [46.81826009584602, 106.43748914047475],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [104.14764404296874, 47.29809208596965],
        [104.16961669921875, 47.32951560950956],
        [104.17098999023436, 47.35650163792198],
        [104.13803100585938, 47.386263315961884],
        [104.095458984375, 47.41229100755385],
        [104.07073974609375, 47.470806305936264],
        [104.15313720703125, 47.525547335516556],
        [104.28909301757812, 47.58486290927609],
        [104.38385009765625, 47.60060732292067],
        [104.4854736328125, 47.59875528481801],
        [104.51019287109375, 47.628380027447136],
        [104.52392578125, 47.65336285044987],
        [104.64614868164061, 47.65521295468833],
        [104.7601318359375, 47.66168780332917],
        [104.72991943359375, 47.7263921299974],
        [104.69558715820312, 47.82883013320963],
        [104.69146728515625, 47.897930761804936],
        [104.710693359375, 47.90989883771289],
        [104.70932006835938, 47.933826688535746],
        [104.68597412109375, 47.954064687296885],
        [104.66537475585938, 47.94762618352869],
        [104.55001831054688, 47.94946583788702],
        [104.44976806640625, 47.96785877999253],
        [104.39346313476562, 47.98624517426206],
        [104.37835693359375, 48.058807426879575],
        [104.33990478515625, 48.10559716402152],
        [104.28634643554688, 48.143181585289554],
        [104.33303833007812, 48.194471974688206],
        [104.36325073242188, 48.25668420754852],
        [104.39895629882812, 48.29781249243716],
        [104.43603515624999, 48.32429984442754],
        [104.50332641601562, 48.355336473558054],
        [104.534912109375, 48.42191010942875],
        [104.53834533691406, 48.53479452317522],
        [104.52838897705078, 48.62564740882851],
        [104.52804565429688, 48.62564740882851],
        [104.8809814453125, 48.53843177405044],
        [104.99359130859375, 48.507506811647325],
        [105.06500244140625, 48.511146022547344],
        [105.15838623046875, 48.545705491847464],
        [105.2490234375, 48.56024979174331],
        [105.31768798828125, 48.59114254808809],
        [105.49346923828125, 48.64561313162894],
        [105.44540405273438, 48.75799945448167],
        [105.57037353515625, 48.816811408054306],
        [105.65139770507811, 48.83579746243093],
        [105.82992553710938, 48.865618158309374],
        [105.9686279296875, 48.84393214092012],
        [106.01943969726562, 48.80957673328024],
        [106.02630615234374, 48.76886223397753],
        [106.00982666015624, 48.731738037020946],
        [105.98785400390625, 48.68824070611104],
        [106.01394653320312, 48.669198799260045],
        [106.0675048828125, 48.64833511799889],
        [106.11145019531249, 48.66012869453836],
        [106.171875, 48.68733411186308],
        [106.44653320312499, 48.592050872804194],
        [106.46301269531249, 48.58296689084418],
        [106.47674560546875, 48.56024979174331],
        [106.578369140625, 48.52933815687993],
        [106.68823242187499, 48.516604348867475],
        [106.7596435546875, 48.532975799741635],
        [106.82418823242188, 48.57933284084407],
        [106.8695068359375, 48.60204136700653],
        [106.98348999023438, 48.60204136700653],
        [107.09335327148438, 48.61747733567233],
        [107.14279174804688, 48.615661584266824],
        [107.20184326171875, 48.59931688270807],
        [107.25128173828125, 48.558431982894355],
        [107.46826171874999, 48.60748989475176],
        [107.52319335937499, 48.63109338958398],
        [107.5836181640625, 48.62564740882851],
        [107.62619018554688, 48.63018576693964],
        [107.65090942382812, 48.64561313162894],
        [107.67013549804688, 48.68552087440201],
        [107.71270751953125, 48.75890477584505],
        [107.73468017578125, 48.81048112472012],
        [107.73056030273438, 48.83579746243093],
        [107.70584106445312, 48.857487002645485],
        [107.63168334960936, 48.879167148960214],
        [107.59597778320312, 48.89812957181126],
        [107.53143310546875, 48.97751295870069],
        [107.59185791015625, 49.017157315497165],
        [107.67288208007812, 49.05677012268616],
        [107.7923583984375, 49.0765646971094],
        [107.85552978515625, 49.0765646971094],
        [107.91046142578125, 49.074765516185],
        [107.99011230468749, 49.0549702248979],
        [108.08761596679688, 49.00995159747052],
        [108.16314697265625, 49.059469847170526],
        [108.23867797851562, 49.08915713896701],
        [108.3306884765625, 49.1170290407793],
        [108.44467163085938, 49.12511795127304],
        [108.52226257324219, 49.124668601968175],
        [108.52088928222655, 49.124668601968175],
        [108.7481689453125, 48.963990624864145],
        [108.8580322265625, 48.80686346108517],
        [108.87451171875, 48.74713432542004],
        [108.91845703124999, 48.66557095325139],
        [108.95965576171875, 48.525700252688765],
        [109.017333984375, 48.40732607972984],
        [109.04205322265625, 48.32156041109599],
        [109.00360107421874, 48.23930899024905],
        [108.96240234375, 48.21735290928554],
        [108.929443359375, 48.17524408990215],
        [108.8909912109375, 48.08358376568458],
        [108.775634765625, 48.028509034432986],
        [108.6712646484375, 47.96050238891509],
        [108.54595184326172, 47.92209422156047],
        [108.45222473144531, 47.90483575868255],
        [108.45291137695312, 47.90529605906089],
        [108.35334777832031, 47.91818280779197],
        [108.27713012695312, 47.868919717114395],
        [108.24829101562499, 47.84265762816535],
        [108.23524475097656, 47.82375912844477],
        [108.21258544921875, 47.782711868678575],
        [108.20159912109374, 47.75040471827431],
        [108.19953918457031, 47.714381682734256],
        [108.21945190429688, 47.6603004033596],
        [108.22700500488281, 47.62004976487241],
        [108.25996398925781, 47.58856790334661],
        [108.30184936523438, 47.57281986733871],
        [108.3526611328125, 47.56355410390809],
        [108.3526611328125, 47.56448075401425],
        [108.5064697265625, 47.349989032003215],
        [108.5394287109375, 47.26432008025478],
        [108.599853515625, 47.22329888685773],
        [108.643798828125, 47.10378387099161],
        [108.7261962890625, 47.02146130911727],
        [108.82095336914062, 46.98118927533914],
        [108.82095336914062, 46.98025235521883],
        [108.7591552734375, 46.894923891703606],
        [108.70697021484375, 46.86113003765812],
        [108.47900390625, 46.78031411656016],
        [108.20159912109374, 46.81509864599243],
        [108.04779052734375, 46.803819640791566],
        [108.00315856933594, 46.793478474902564],
        [107.9568099975586, 46.77467126314099],
        [107.9571533203125, 46.77514152351191],
        [107.85621643066406, 46.761972680830375],
        [107.85072326660155, 46.72291755083757],
        [107.84042358398438, 46.68336307047754],
        [107.83561706542969, 46.62350543010974],
        [107.81845092773438, 46.58576581737151],
        [107.78274536132812, 46.56641407568593],
        [107.74841308593749, 46.55980458220511],
        [107.67494201660156, 46.553666474384535],
        [107.63031005859375, 46.542332758884484],
        [107.60215759277344, 46.527689873863785],
        [107.53692626953125, 46.464822363804686],
        [107.369384765625, 46.41892578708076],
        [107.1002197265625, 46.403776166694634],
        [107.03704833984375, 46.43217825300941],
        [106.89834594726562, 46.526745036021474],
        [106.79946899414062, 46.55980458220511],
        [106.68548583984375, 46.574910812684244],
        [106.16363525390625, 46.57585481240773],
        [106.1224365234375, 46.617374532060765],
        [106.05926513671875, 46.63435070293566],
        [105.91094970703125, 46.6795944656402],
        [105.84228515625, 46.72480037466717],
        [105.7598876953125, 46.73609593770121],
        [105.65826416015625, 46.71350244599995],
        [105.4742431640625, 46.543749602738565],
        [105.39459228515624, 46.437856895024225],
        [105.22979736328125, 46.526745036021474],
        [104.96612548828124, 46.59095657312452],
        [104.85626220703124, 46.49650154751426],
        [104.776611328125, 46.46056554578543],
        [104.65353012084961, 46.380451731783644],
        [104.6531867980957, 46.380570155101864],
        [104.60769653320311, 46.417979059090115],
        [104.56512451171875, 46.443534945303284],
        [104.43878173828125, 46.50595444552051],
        [104.403076171875, 46.52863469527167],
        [104.39208984375, 46.569246469250054],
        [104.39208984375, 46.65697731621612],
        [104.3756103515625, 46.70408569832255],
        [104.34814453125, 46.73233101286786],
        [104.32342529296875, 46.76996843356982],
        [104.23416137695312, 46.853617401905105],
        [104.2657470703125, 46.87990702860919],
        [104.30145263671875, 46.89680070399431],
        [104.34539794921875, 46.903369029728054],
        [104.35638427734375, 46.95869866086379],
        [104.3536376953125, 46.997114405385986],
        [104.33578491210938, 47.034566583590426],
        [104.31106567382811, 47.05608969226366],
        [104.249267578125, 47.09537035351024],
        [104.20120239257811, 47.124344650121884],
        [104.17098999023436, 47.1607737815166],
        [104.15313720703125, 47.21583707523794],
        [104.1448974609375, 47.25919416818626],
        [104.14833068847656, 47.29879058949732],
        [104.14764404296874, 47.29809208596965],
      ],
    ],
  },
};
